<template>

  <div class="">
    <form @submit.prevent="search()" class="form2 border-bottom border-dark">
      <a class="button-Search bg-transparent ">
        <b-icon icon="search"></b-icon>
      </a>
      <input
          class="input-search"
          type="text"
          placeholder="جستجو..."
          name="search"
          required
          v-model="words"
      />
    </form>
  </div>

</template>

<script>
import router from "@/router";

export default {
  name: "SearchInput2",
  data() {
    return {
      words: '',
      type: 'product',
    }
  },
  methods: {
    search() {
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    }
  },
}
</script>

<style scoped>


.form2 {
  position: relative;
}

.form2 input {
  width: 100%;
  border: none !important;
  box-shadow: none;
  padding: 10px 15px;
  color: var(--gray-dark) !important;
  background-color: transparent;
}

.form2 .button-Search {
  position: absolute;
  left: 0;
  color: var(--gray-dark) !important;
  padding: 8px 25px;
  border-radius: 200px;
  cursor: pointer;
  height: 100%;
}

input:focus {
  outline: none;
  border: none;
}


</style>